import Metrics from './metrics.html';
import controller from './metrics.controller';
import './metrics.styl';

let metricsComponent = {
  restrict: 'E',
  template: Metrics,
  controller,
  bindings: {
    currentTimesheet: '='  // One-way data binding
  },
};

export default metricsComponent;



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/metrics/metrics.component.js